import TEXT from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";

const ScheduleInternalTransactionStepAmount = ({
  txnPayLoad,
  isRtgs,
  slideAnimation,
  handleAmountChange,
  handleNeftClick,
  handleRtgsClick,
}) => {
  return (
    <div
      className="w-width-full h-height-full items-start px-padding-md lg:px-padding-base py-padding-md"
      style={{ scrollbarWidth: "none" }}
    >
      <CommonLayout>
        <Amount
          title={TEXT.TRANSFER_AMOUNT}
          amount={txnPayLoad?.amount}
          amountInWords={txnPayLoad?.amountInWords}
          copyData={null}
          onAmountChange={(value) =>
            handleAmountChange({ name: "amount", value })
          }
          onPasteApplied={() => {}}
          isPreview={false}
          txnPayLoad={txnPayLoad}
        />

        <PaymentMethodSelector
          title={TEXT.SELECT_PAYMENT_METHOD}
          slideAnimation={slideAnimation}
          previewMode={false}
          autoSwitchDisabled={true}
          methods={[
            {
              key: "neft",
              label: TEXT.NEFT,
              subText: TEXT.NEFT_TRANSFER_NOTE,
              active: !isRtgs,
              notes: [
                TEXT.TRANSACTION_EXECUTION_NOTE,
                TEXT.TRANSACTION_LIMIT_NOTE,
                TEXT.TRANSACTION_CHARGES_NOTE,
              ],
              onClick: handleNeftClick,
            },
            {
              key: "rtgs",
              label: TEXT.RTGS,
              subText: TEXT.INSTANT_TRANSFER_NOTE,
              active: isRtgs,
              notes: [
                TEXT?.RTGS_TRANSACTION_EXECUTION_NOTE,
                TEXT?.RTGS_TRANSACTION_LIMIT_NOTE,
                TEXT.TRANSACTION_CHARGES_NOTE,
              ],
              onClick: handleRtgsClick,
            },
          ]}
        />
      </CommonLayout>

      <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
    </div>
  );
};

export default ScheduleInternalTransactionStepAmount;
